import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import React from "react";
import { useHistory } from "react-router";
import { ERoutes } from "../../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { ClubRoleApi, ClubRoleGridDto, ClubRoleSearch } from "../../../../api";

export interface IClubRoleListPageProps {}

export const ClubRoleListPage: React.FunctionComponent<IClubRoleListPageProps> = (props) => {
  const clubRoleApi = useApiService(ClubRoleApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: ClubRoleGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.clubRoles}/${row.clubRoleId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.clubRoles}/${row.clubRoleId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      { fieldName: "name", header: () => t(ETLCodes.Name) },
    ],
    [history, t]
  );

  const addItem = React.useCallback(() => {
    history.push(`${ERoutes.clubRoles}/${0}/detail/edit`);
  }, [history]);

  const searchCriteriasFunction = React.useCallback(() => clubRoleApi.getSearchCriterias(true), [clubRoleApi]);
  const searchFunction = React.useCallback(
    (sObj) => clubRoleApi.baseSearch(ClubRoleSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [clubRoleApi, currentLanguage.languageId]
  );
  const exportFunction = React.useCallback(
    (sObj) => clubRoleApi.exportXlsFile(ClubRoleSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [clubRoleApi, currentLanguage.languageId]
  );

  return (
    <>
      <SearchTablePage
        columns={columns}
        getCriteriasFunction={searchCriteriasFunction}
        searchFunction={searchFunction}
        exportFunction={exportFunction}
        addFunc={addItem}
        sortKeys={{ name: "ASC" }}
        breadCrumbs={[{ text: t(ETLCodes.ClubRoles) }]}
      />
    </>
  );
};
